
import api from '@/api';

const ACCESS_TOKEN_LS_KEY = `nestorr:auth:accessToken`;
const REFRESH_TOKEN_LS_KEY = `nestorr:auth:refreshToken`;

const namespaced = true;

const state = {
  accessToken: null,
  refreshToken: null,
  spaces: [],
  isUnifiedUser: false,
};

const mutations = {
  SET_CREDENTIALS(state, { accessToken, refreshToken }) {
    state.accessToken = accessToken || null;
    state.refreshToken = refreshToken || null;
  },
  SET_SPACES(state, spaces) {
    state.spaces = spaces;
  },
  SET_IS_UNIFIED_USER(state, isUnifiedUser) {
    state.isUnifiedUser = isUnifiedUser;
  },
};

const actions = {
  async login({ commit, dispatch }, { slug = null, username, password }) {
    commit(`SET_SPACES`, []);
    try {
      const { data: credentials } = await api.post(`/auth/login`, { slug, username, password });
      if (credentials.ssoToken) {
        return credentials;
      }
      if (credentials?.spaces?.length) {
        commit(`SET_SPACES`, credentials.spaces);
        if (credentials?.accessToken && credentials?.refreshToken) {
          return dispatch(`saveCredentials`, credentials);
        }
      } else if (credentials?.accessToken && credentials?.refreshToken) {
        return dispatch(`saveCredentials`, credentials);
      }
    } catch (e) {
      return dispatch(`saveCredentials`, {});
    }

    return null;
  },
  async ssoLogin({ dispatch }, token) {
    try {
      const { data: credentials } = await api.post(`/auth/sso`, { token });
      await dispatch(`saveCredentials`, credentials);
    } catch (e) {
      await dispatch(`saveCredentials`, {});
    }
  },
  async logout({ commit, dispatch }) {
    await dispatch(`saveCredentials`, {});
    commit(`SET_SPACES`, []);
    commit(`model/user/SET_ME`, null, { root: true });
  },
  saveCredentials({ dispatch }, { accessToken, refreshToken }) {
    window.localStorage.setItem(ACCESS_TOKEN_LS_KEY, accessToken || ``);
    window.localStorage.setItem(REFRESH_TOKEN_LS_KEY, refreshToken || ``);
    dispatch(`loadCredentials`);
  },
  loadCredentials({ commit }) {
    const accessToken = window.localStorage.getItem(ACCESS_TOKEN_LS_KEY);
    const refreshToken = window.localStorage.getItem(REFRESH_TOKEN_LS_KEY);

    commit(`SET_CREDENTIALS`, { accessToken, refreshToken });
  },
  async initPassword(store, { username }) {
    try {
      await api.post(`/auth/init-password`, { username });
      return true;
    } catch (e) {
      return false;
    }
  },
  async testInitPasswordToken(store, { token }) {
    try {
      await api.post(`/auth/test-init-password`, { token });
      return true;
    } catch (e) {
      return false;
    }
  },
  async getInitAccountData(store, { token }) {
    try {
      const { data: initAccountData } = await api.post(`/auth/init-account-data`, { token });
      return initAccountData;
    } catch (e) {
      return {};
    }
  },
  async setPassword(store, { token, password }) {
    try {
      const { data: user } = await api.post(`/auth/set-password`, { token, password });
      return user;
    } catch (e) {
      return null;
    }
  },
  async initAccount(store, data) {
    try {
      const { data: user } = await api.post(`/auth/init-account`, data);

      return user;
    } catch (e) {
      return null;
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
